import React, { useState } from 'react'
import { Routes, Route, Link, useLocation, useMatch } from 'react-router-dom';
import List from './List';
import Details from './Details';
import OnBoarding from './onboarding';
import { Header } from 'semantic-ui-react'
function Organizations() {
  const [showHeaderTxt, setShowHeaderTxt] = useState(true)
  const location = useLocation();
  const matchOnboarding = useMatch('details/:id/onboarding/*');
  const matchDetails = useMatch('details/:id/*');
  const orgId = (matchOnboarding && matchOnboarding.params?.id) || (matchDetails && matchDetails.params?.id) || null;
  const onDetailsRoute = Boolean(matchDetails);
  return (
    <div style={{ marginTop: "30px" }} className="w-full">
      {showHeaderTxt &&
        <HeaderText />
      }
      {onDetailsRoute && orgId && (
        <div className="mb-3">
          <div role="tablist" className="flex gap-4 border-b">
            <Link
              role="tab"
              to={`/app/organizations/details/${orgId}`}
              className={`px-2 pb-2 -mb-px border-b-2 ${location.pathname.includes('/onboarding') ? 'border-transparent text-muted-foreground' : 'border-foreground text-foreground'}`}
            >
              Overview
            </Link>
            <Link
              role="tab"
              to={`/app/organizations/details/${orgId}/onboarding`}
              className={`px-2 pb-2 -mb-px border-b-2 ${location.pathname.includes('/onboarding') ? 'border-foreground text-foreground' : 'border-transparent text-muted-foreground'}`}
            >
              Onboarding
            </Link>
          </div>
        </div>
      )}
      <Routes>
        <Route path="/" element={<List
          setShowHeaderTxt={setShowHeaderTxt} />} />

        <Route path="details/:id/*" element={<Details

          setShowHeaderTxt={setShowHeaderTxt} />} />
        <Route
          path="details/:id/onboarding/*"
          element={<OnBoarding
            setShowHeaderTxt={setShowHeaderTxt} />} />
      </Routes>
    </div>
  );
}

export default Organizations;

function HeaderText() {
  return (
    <Header as='h2' >
      Organizations
      <Header.Subheader>
        List of All Organizations and a place to manage them.
      </Header.Subheader>
    </Header>
  )
}